import React, { useState, useEffect } from 'react';
import styles from '../../UserKycComponent/UserElectricityBill/UserElectricity.module.css';
import * as Yup from 'yup';
import get from 'lodash/get';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonPincode from '../../../../components/Dashboard-res/CommonComponent/CommonPincode';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import initialImg from '../../../../images/icons/upload_new.svg';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import { StateList } from '../../../../common/constants/StateList';
import { Formik, Form } from 'formik';
import AddresssProofImage from '../../../../images/icons/UserKycIcons/addressproof_icon.svg';
import PopUp from '../../../../common/components/PopUp/PopUp';
import {
  getStatesList,
  getBoardsList,
  UploadUserElectricityBill,
  UploadFileToS3,
  ConfirmingUserElectricityUploads,
  saveKYCElectricityAddressProof,
  getElectricityAddressDetails,
  getUserKYCElectricity
} from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import mb_reupload from '../../../../images/icons/mb_upload.svg';

const validationSchema = Yup.object().shape({
  consumerID: Yup.string().required('Required'),

  address_line_1: Yup.string()
    .required('Required')
    .min(10, 'Too Short'),
  city: Yup.string().required('Required'),
  state: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  pincode: Yup.string()
    .required('Required')
    .max(6, 'Pincode should be 6 digit numbers')
    .matches(/\d{6}/, 'Pincode should be digits only')
});

const UserElectricityBill = props => {
  const {
    electricity_container,
    electricity_details_container,
    align_city_state,
    align_state
  } = styles;

  const [LeadId, SetLeadId] = useState(getApplicantionInfo().leadId);
  const [ApplicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [DocId, setDocID] = useState(false);
  const [ShowUploadBlock, setShowUploadBlock] = useState(false);
  const [ShowUploadButton, setShowUploadButton] = useState(false);
  const [statusFilterList, setStatusFilterList] = useState([]);
  const [statusFilterListId, setStatusFilterListId] = useState([]);
  const [isError, setError] = useState(false);
  const [showErrorMessage, setErrorMessage] = useState(false);
  const [showNextButton, setShowNextButton] = useState(false);
  const [showDetail, setShowDetail] = useState('');
  const [Loading, setLoading] = useState(false);
  const [LoadingFail, setLoadingFail] = useState(false);
  const [eBoard, setEBoard] = useState([]);
  const [eBoardName, setEBoardName] = useState('');
  const [eStateBoardId, setEStateBoardId] = useState('');
  const [dataAddress, setDataAddress] = useState('');
  const [imgLinkData, setImgLinkData] = useState(null);
  const [uploadDone, setUploadDone] = useState(false);
  const [Edit, setEdit] = useState(false);
  return (
    <Formik
      initialValues={{
        stateID: { value: '', label: 'Select State' },
        board: { value: '', label: 'Select Board' },
        file: [],
        imgUrl: [],
        address_line_1: '',
        address_line_2: '',
        city: '',
        state: { value: '', label: 'Select State' },
        pincode: '',
        consumerID: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        setLoading(true);

        let body = {
          line1: data?.address_line_1,
          line2: data?.address_line_2,
          city: data?.city,
          state: data?.state.value,
          pinCode: data?.pincode,
          stateID: data?.stateID.value,
          electricityBoard: data?.board.value,
          consumerId: data?.consumerID
        };
        saveKYCElectricityAddressProof(LeadId, ApplicantId, body)
          .then(res => {
            if (res.error) {
              throw new Error(res.error.data.message);
            }
            setLoading(false), props.handleSubmit();
          })
          .catch(err => {
            setLoading(false);
            setErrorMessage(err);
            setError(true);
            setLoadingFail(true);
            setTimeout(function() {
              setError(false);
              setErrorMessage('');
            }, 3000);
          });
      }}
    >
      {({
        values: data,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting
      }) => {
        useEffect(() => {
          setUploadDone(false);
          setShowDetail(false);
          setEdit(true);
          setFieldValue('file', []);
        }, [data.board.value]);

        useEffect(() => {
          let StateListArray = [];
          StateList()
            .sort()
            .map(each =>
              StateListArray.push({
                label: each,
                value: each
              })
            );
          setStatusFilterList(StateListArray);
        }, []);

        useEffect(() => {
          let StateListIdArray = [];
          getStatesList().then(data => {
            data.map(each =>
              StateListIdArray.push({
                label: each.name,
                value: each.name,
                id: each.id
              })
            );

            setStatusFilterListId(StateListIdArray);
          });
        }, []);
        useEffect(() => {
          let BoardListIdArray = [];
          getBoardsList(eStateBoardId).then(data => {
            data.map(each =>
              BoardListIdArray.push({
                label: each?.board || 'Select Board',
                value: each?.board || '',
                code: each.code
              })
            );
            setEBoard(BoardListIdArray);
            setShowDetail(false);
            setEdit(true);
          });
        }, [eStateBoardId]);

        useEffect(() => {
          setLoading(true);

          const setDataAddress = async res => {
            if (res.links.length > 0) {
              await setImgLinkData(res?.links?.[0]);
              setFieldValue('consumerID', res?.userData?.consumerId || '');
              setFieldValue(
                'board',
                res?.userData?.electricityBoard || 'Select'
              );

              await setImgLinkData(res?.links?.[0]);
              setFieldValue('consumerID', res?.userData?.consumerId || '');

              setFieldValue('board', {
                value: res?.userData?.electricityBoard || '',
                label: res?.userData?.electricityBoard
              });

              if (res?.userData?.address) {
                let getData = res.userData.address;
                if (!res.userData.consumerId) {
                  setShowNextButton(true);
                  setShowDetail(false);
                  setUploadDone(false);
                } else {
                  setError(false);
                  setUploadDone(true);
                  setShowUploadButton(false);
                  setErrorMessage('');
                  setShowDetail(true);
                  setShowNextButton(false);
                }

                setFieldValue('address_line_1', getData?.line1 || '');
                setFieldValue('address_line_2', getData?.line2 || '');
                setFieldValue('pincode', getData?.pinCode || '');
                setFieldValue('city', getData?.city || '');
                setFieldValue('state', {
                  value: getData?.state || '',
                  label: getData?.state || 'Select'
                });
                setShowNextButton(false);
                setShowUploadButton(false);
                setShowDetail(true);
                setUploadDone(true);
                setEdit(false);
              } else {
                setUploadDone(false);
                setShowUploadButton(false);
                setShowDetail(false);
                setShowNextButton(false);
              }
              setLoading(false);
            } else {
              setLoading(false);
            }
          };

          getUserKYCElectricity(LeadId, ApplicantId)
            .then(res => {
              setDataAddress(res);
            })
            .catch(err => {
              setLoading(false);
              setLoadingFail(true);
            });
          setLoading(false);
        }, []);

        const handleError = message => {
          setLoading(false);
          setUploadDone(false);
          setShowDetail(false);
          setFieldValue('file', []);
          setFieldValue('imgUrl', []);
          setError(true);
          setShowUploadButton(false);
          setErrorMessage(message);
          setTimeout(function() {
            setError(false);
            setErrorMessage('');
          }, 2000);
        };

        const uploadFile = () => {
          setLoading(true);
          UploadUserElectricityBill(data.file[0][0], LeadId, ApplicantId)
            .then(res => {
              if (res.error) {
                throw new Error(res.error.data.message);
              }
              setDocID(res.requestId);
              UploadFileToS3(res.url, data.file[0][0])
                .then(res1 => {
                  if (res1.error) {
                    throw new Error(res1.error.data.message);
                  }
                  ConfirmingUserElectricityUploads(
                    LeadId,
                    ApplicantId,
                    res.requestId
                  )
                    .then(res2 => {
                      if (res2.error) {
                        throw new Error(res2.error.data.message);
                      }
                      setLoading(false);
                      setUploadDone(true);
                    })
                    .catch(err => {
                      handleError(err);
                    });
                })
                .catch(errUpload => {
                  handleError(errUpload);
                });
            })
            .catch(getS3Urlerror => {
              handleError(getS3Urlerror);
            });
        };

        useEffect(() => {
          if (eBoardName != '' || data.consumerID !== '') {
            setShowUploadBlock(true);
          } else {
            setShowUploadBlock(false);
          }
        }, [data.board.value]);
        useEffect(() => {
          if (data.file.length == 1 && data.imgUrl[0]) {
            setShowUploadButton(true);
            //setShowNextButton(false)
            setShowDetail(true);
          } else {
            setShowUploadButton(false);
          }
        }, [data.imgUrl[0]]);

        const getElectricityAddress = async () => {
          setLoading(true);
          await getElectricityAddressDetails(
            LeadId,
            ApplicantId,
            eBoardName,
            data.consumerID
          )
            .then(res => {
              if (res) {
                setFieldValue('name', res?.name, '');
                setFieldValue('address_line_1', res?.address, '');
              }
            })
            .catch(err => {});

          setShowNextButton(false);
          setLoading(false);
          setLoadingFail(true);
        };

        const backToInitialState = () => {
          setLoading(false);

          setShowUploadBlock(false);
          setShowUploadButton(false);
          setShowNextButton(false);
          setErrorMessage('');
          setImgLinkData(null);
          setFieldValue('consumerID', '');
          setFieldValue('board', '');
          setFieldValue('stateID', '');
          setShowDetail(false);
          setUploadDone(false);
        };

        useEffect(() => {
          if (Edit) {
            backToInitialState();
          }
        }, [Edit]);

        const showImage = (image, setEdit) => {
          return (
            <div
              className="relative w-44 h-28 mx-auto"
              style={{ minWidth: '16rem' }}
            >
              <div
                id="img"
                onClick={e => {
                  if (image) {
                    window.open(image, '_blank');
                  }
                }}
                className="w-44 h-28 bg-white my-2 relative mx-auto "
              >
                <img
                  src={image}
                  alt="image"
                  className="w-40 h-28"
                  style={{ width: '100% ' }}
                />
              </div>
              <div
                onClick={() => setEdit(true)}
                className="absolute z-50 top-0 right-0 -mt-3 -mr-4 cursor-pointer "
              >
                <img className="h-12 w-12" src={mb_reupload} alt="re-upload" />
              </div>
            </div>
          );
        };

        return (
          <Form autoComplete="off" className="pt-2 sm:px-5 ">
            <div className={`${electricity_container}`}>
              <div className="block md:hidden w-full bg-blue-100 flex  py-4 rounded px-2 items-center">
                <div className="w-4/12 ">
                  <img src={AddresssProofImage} />
                </div>
                <div className="w-7/12 block px-2 ">
                  <p className="font-roboto font-normal text-blue-800">
                    Step 3
                  </p>
                  <p className="font-roboto font-normal text-blue-800">
                    Now please upload Current address proof
                  </p>
                </div>
              </div>
              <div className="w-full md:w-5/12 mr-auto mb-4 md:py-1">
                <div className="text-black-600 font-roboto font-normal text-md font-bold pb-2 mb-4 md:py-0">
                  Choose State
                </div>

                <CommonSelect sort={true}
                  name="stateID"
                  value={data.stateID}
                  onChange={e => {
                    setFieldValue('stateID', {
                      value: e.value,
                      label: e.value
                    });
                    setEStateBoardId(e.id);
                  }}
                  options={statusFilterListId}
                  isHoverEffect
                  stylesContainer={{
                    height: '52px',
                    width: '200px',
                    marginBottom: '0px',
                    fontSize: '40px'
                  }}
                  dropdownStyle={{
                    top: '52px',
                    color: 'rgba(0,0,0,0.87)',
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    alignItems: 'center',
                    fontFamily: 'Roboto',
                    fontWeight: 400
                  }}
                  styleText={{
                    fontSize: '14px',
                    padding: '0 25px'
                  }}
                  error={touched.stateID && get(errors, 'stateID.value', false)}
                  touched={touched.stateID}
                  onBlur={() => {}}
                />
              </div>

              {eStateBoardId && (
                <div className="w-full md:w-5/12 mr-auto mb-4 md:py-1">
                  <div className="text-black-600 font-roboto font-normal text-md font-bold pb-2 mb-2 md:py-0">
                    Choose Board
                  </div>
                  <CommonSelect sort={true}
                    name="board"
                    value={data.board}
                    onChange={e => {
                      setFieldValue(
                        'board',
                        { value: e.value, label: e.label },
                        true
                      );
                      setEBoardName(e.code);
                    }}
                    options={eBoard}
                    stylesContainer={{
                      height: '62px',
                      width: '200px',
                      marginBottom: '0px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '52px',
                      color: 'rgba(0,0,0,0.87)',
                      fontSize: '16px',
                      backgroundColor: '#fff',
                      alignItems: 'center',
                      fontFamily: 'Roboto',
                      fontWeight: 400
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 20px'
                    }}
                    touched={touched.board}
                  />
                </div>
              )}
              {ShowUploadBlock && (
                <React.Fragment>
                  <p className="text-lg text-black-850 font-roboto font-medium">
                    Upload Electricity Bill
                  </p>

                  <div className="flex justify-around pt-5">
                    {imgLinkData?.url && !Edit ? (
                      showImage(imgLinkData?.url, setEdit)
                    ) : (
                      <GlobalUploadComp
                        data={data}
                        imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        showFullImage // boolean , to change mobile upload image view
                        initialImg={initialImg} // initial image
                        subInst="Click here to upload"
                        subtext="CHOOSE IMAGE"
                      />
                    )}
                  </div>
                </React.Fragment>
              )}

              {ShowUploadButton && (
                <button
                  className={`submitButton w-48 ${
                    uploadDone ? 'hidden' : 'block'
                  }`}
                  type="button"
                  onClick={() => {
                    if (ShowUploadButton && data.file[0]) {
                      uploadFile();
                      setUploadDone(true);
                      setShowUploadButton(false);
                      setShowNextButton(true);
                    }
                  }}
                >
                  UPLOAD
                </button>
              )}
              {uploadDone && (
                <div className="mt-8 m-auto max-w-xs">
                  <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                    <CommonInput
                      name="consumerID"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={data.consumerID}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                      legendName="Consumer ID"
                      error={touched.consumerID && errors.consumerID}
                      errorMsg={errors.consumerID}
                      touched={touched.consumerID}
                    />
                  </div>
                  {showNextButton && (
                    <button
                      className={`submitButton w-48 ${
                        Edit == false ? 'hidden' : 'block'
                      }`}
                      type="button"
                      onClick={() => {
                        getElectricityAddress();
                        setShowNextButton(false);
                        setEdit(false);
                      }}
                    >
                      NEXT
                    </button>
                  )}
                </div>
              )}

              {(showDetail === true || imgLinkData !== null) && (
                <div className={`${Edit ? 'hidden' : 'block'}`}>
                  <div
                    className={`${electricity_details_container} px-5 md:px-0 ${
                      Edit ? 'pt-12' : 'pt-0'
                    }`}
                  >
                    <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                      <CommonInput
                        name="address_line_1"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={data.address_line_1}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="Address Line 1"
                        error={touched.address_line_1 && errors.address_line_1}
                        errorMsg={errors.address_line_1}
                        touched={touched.address_line_1}
                      />
                    </div>
                    <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                      <CommonInput
                        name="address_line_2"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={data.address_line_2}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="Address Line 2"
                        error={touched.address_line_2 && errors.address_line_2}
                        errorMsg={errors.address_line_2}
                        touched={touched.address_line_2}
                      />
                    </div>
                    <div className={`${align_city_state}`}>
                      <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                        <CommonInput
                          name="city"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.city}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="City"
                          error={touched.city && errors.city}
                          errorMsg={errors.city}
                          touched={touched.city}
                        />
                      </div>
                      <div
                        className={`${align_state} mb-8 font-normal font-roboto text-sm text-black-500`}
                      >
                        <div className="text-black-600 font-roboto font-normal text-xs pb-1 md:py-0">
                          State
                        </div>

                        <CommonSelect sort={true}
                          name="state"
                          onChange={handleChange}
                          value={data.state}
                          onChange={e => {
                            setFieldValue('state', {
                              value: e.value,
                              label: e.value
                            });
                          }}
                          onBlur={() => {
                            setFieldTouched('state', true, true);
                          }}
                          options={statusFilterList}
                          isHoverEffect
                          stylesContainer={{
                            marginBottom: '0px',
                            fontSize: '40px',
                            height: '52px'
                          }}
                          dropdownStyle={{
                            top: '52px',
                            color: 'rgba(0,0,0,0.87)',
                            fontSize: '16px',
                            backgroundColor: '#fff',
                            alignItems: 'center',
                            fontFamily: 'Roboto',
                            fontWeight: 400
                          }}
                          styleText={{
                            fontSize: '14px',
                            padding: '0 6px',
                            backgroundColor: 'white'
                          }}
                          error={
                            touched.state && get(errors, 'state.value', false)
                          }
                          touched={touched.state}
                        />
                      </div>
                    </div>
                    <CommonPincode
                      name="pincode"
                      value={data.pincode}
                      onChange={e => {
                        if (e.target.value.length <= 6) {
                          setFieldValue('city', '');
                          setFieldValue('pincodeState', '');
                        }
                        handleChange(e);
                      }}
                      error={errors?.pincode && touched?.pincode}
                      errorMsg={errors?.pincode}
                      touched={touched?.pincode}
                      onPinCodeSucessOrFailure={obj => {
                        const { err, data: pincodeData } = obj;
                        if (!err && pincodeData) {
                          setFieldValue('city', pincodeData.District);
                          setFieldValue('pincodeState', pincodeData.State);
                        } else {
                          setFieldError('pincode', 'Pincode is not valid');
                        }
                      }}
                      onBlur={e => {
                        handleBlur(e);
                      }}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                    />
                  </div>

                  <button
                    className={
                      ' submitButton text-14 w-56 h-12 font-medium  font-roboto'
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit();
                      setUploadDone(true);
                    }}
                    disabled={
                      errors.address_line_1 ||
                      data.address_line_1 == '' ||
                      errors.city ||
                      data.city == '' ||
                      errors?.state?.value ||
                      data?.state?.value == '' ||
                      errors.pincode ||
                      data.pincode == ''
                    }
                  >
                    Save & Verify
                  </button>
                </div>
              )}
            </div>
            {Loading || isError ? (
              <PopUp
                autoClose={false}
                type={Loading ? 'loading' : isError ? 'fail' : null}
                text={Loading ? 'Loading ....' : showErrorMessage.toString()}
                setShow={() => {}}
                autoClose={false}
                show={true}
              />
            ) : null}{' '}
          </Form>
        );
      }}
    </Formik>
  );
};
export default UserElectricityBill;
